import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ApiService } from 'app/providers/api.service';
import { DropDownFilterService } from 'app/providers/filters.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

export interface DSHeaderJSON {
  shw_hdr: boolean;
  title: string;
  sub_title?: string;
  shw_fltr: boolean;
  shw_refresh_in?: boolean; 
  shw_bck_btn_in?: boolean;
  srch_in?: boolean;
  srch_ph_tx?: string;
  fltr_jsn?: {
    dsply_fltr_cd: 'fltr_states' | 'fltr_mandal' | 'fltr_district' | 'fltr_sachivalayam' | 'fltr_ward' | 'fltr_wrkctgry' | 'fltr_sbwrk_ctgry' | 'fltr_file_type' | 'fltr_main_stg' | 'fltr_min_amnt' | 'fltr_max_amnt' | 'fltr_gp' | 'fltr_habitation' | 'fltr_work_type' | 'fltr_work_sub_type' | 'fltr_work_nature' | 'fltr_work_status' | 'ast_ctgry_id' | 'ast_type_id' | 'ast_grp_id' | 'ast_cd' | 'vndr_ast_cd' | 'fltr_prtlSte' | 'fltr_imprtLnks' | 'fltr_docCtgry' | 'fltr_pgEdt' | 'fltr_sectors' | 'fltr_schme' | 'fltr_trnch' | 'fltr_dsgns' | 'fltr_asgn_emp' | 'fltr_cnstncy' | 'fltr_fromdate' | 'fltr_todate'
    fltr_dflt_val: string
  }[],
}

@Component({
  selector: 'ds-cstm-header',
  templateUrl: './cstm-header.component.html',
  styleUrls: ['./cstm-header.component.scss']
})


export class CstmHeaderComponent {

  @Input() dsHeader: DSHeaderJSON;
  @Output() onGetFilterActionEvntEmtr = new EventEmitter();
  minAmount: number | null = null;
  maxAmount: number | null = null;
  years: number[] = [];
  selectedYear: number;
  catid: any;
  flag: boolean = false;
  asrtForm: FormGroup;
  catAsstCode: any;
  catAsstVndrCode: any;
  catType: any;
  catgryGrp: any;
  categories: any;
  types: any;
  groups: any;
  fType: any;
  shwLdng
  settings = {
    opn_fltrs: false,
    shw_all_sclt: false,
    fltrs_stngs: [
      {
        dsply_fltr_cd: 'fltr_states',
        fltr_dflt_val: '',
        api_call_fun: () => this.getStates(),

      },
      {
        dsply_fltr_cd: 'fltr_district',
        fltr_dflt_val: '',
        api_call_fun: () => this.getDistricts(),

      },
      {
        dsply_fltr_cd: 'fltr_cnstncy',
        fltr_dflt_val: '',
        api_call_fun: () => this.getConstuency(),

      },
      {
        dsply_fltr_cd: 'fltr_mandal',
        fltr_dflt_val: '',
        api_call_fun: () => this.getMandals(),

      },
      {
        dsply_fltr_cd: 'fltr_gp',
        fltr_dflt_val: '',
        // api_call_fun: null,
        api_call_fun: () => this.getGP(),

      },
      {
        dsply_fltr_cd: 'fltr_sachivalayam',
        fltr_dflt_val: '',
        api_call_fun: () => this.getSvmLst(),

      },

      {
        dsply_fltr_cd: 'fltr_ward',
        fltr_dflt_val: '',
        api_call_fun: () => this.getwrdsLst(),

      },
      {
        dsply_fltr_cd: 'fltr_wrkctgry',
        fltr_dflt_val: '',
        api_call_fun: () => this.getwrktyps(),

      },
      {
        dsply_fltr_cd: 'fltr_sbwrk_ctgry',
        fltr_dflt_val: '',
        api_call_fun: () => this.getSubWorkType,

      },
      {
        dsply_fltr_cd: 'fltr_file_type',
        fltr_dflt_val: '',
        api_call_fun: () => this.getfiletype(),

      },
      {
        dsply_fltr_cd: 'fltr_main_stg',
        fltr_dflt_val: '',
        api_call_fun: () => this.getmStages(),

      },
      {
        dsply_fltr_cd: 'fltr_min_amnt',
        fltr_dflt_val: '',
        api_call_fun: null,

      },
      {
        dsply_fltr_cd: 'fltr_max_amnt',
        fltr_dflt_val: '',
        api_call_fun: null,

      },
      {
        dsply_fltr_cd: 'fltr_habitation',
        fltr_dflt_val: '',
        api_call_fun: null,

      },
      {
        dsply_fltr_cd: 'fltr_work_type',
        fltr_dflt_val: '',
        api_call_fun: () => this.getWorkType(),

      },
      {
        dsply_fltr_cd: 'fltr_work_sub_type',
        fltr_dflt_val: '',
        api_call_fun: () => this.getsubWorkType(),

      },
      {
        dsply_fltr_cd: 'fltr_work_nature',
        fltr_dflt_val: '',
        api_call_fun: () => this.getWorkNtre(),

      },
      {
        dsply_fltr_cd: 'fltr_work_status',
        fltr_dflt_val: '',
        api_call_fun: () => this.getWorkStats(),

      },
      {
        dsply_fltr_cd: 'ast_ctgry_id',
        fltr_dflt_val: '',
        api_call_fun: () => this.getCategories(),

      },
      {
        dsply_fltr_cd: 'ast_grp_id',
        fltr_dflt_val: '',
        api_call_fun: () => this.getGroups(),

      },
      {
        dsply_fltr_cd: 'ast_type_id',
        fltr_dflt_val: '',
        api_call_fun: () => this.getType(),

      },
      {
        dsply_fltr_cd: 'ast_cd',
        fltr_dflt_val: '',
        api_call_fun: null,

      },
      {
        dsply_fltr_cd: 'vndr_ast_cd',
        fltr_dflt_val: '',
        api_call_fun: null,

      },
      {
        dsply_fltr_cd: 'fltr_prtlSte',
        fltr_dflt_val: '',
        api_call_fun: () => this.getSiteLst(),

      },
      {
        dsply_fltr_cd: 'fltr_imprtLnks',
        fltr_dflt_val: '',
        api_call_fun: () => this.getLinksCtgry(),

      },
      {
        dsply_fltr_cd: 'fltr_docCtgry',
        fltr_dflt_val: '',
        api_call_fun: () => this.getDocCtgry(),

      },
      {
        dsply_fltr_cd: 'fltr_pgEdt',
        fltr_dflt_val: '',
        api_call_fun: () => this.getPgEdt(),

      },
      {
        dsply_fltr_cd: 'fltr_sectors',
        fltr_dflt_val: '',
        api_call_fun: () => this.getSctrsLst(),

      },

      {
        dsply_fltr_cd: 'fltr_schme',
        fltr_dflt_val: '',
        api_call_fun: () => null,

      },


      {
        dsply_fltr_cd: 'fltr_trnch',
        fltr_dflt_val: '',
        api_call_fun: () => this.getTrenchLst(),

      },

      {
        dsply_fltr_cd: 'fltr_fromdate',
        fltr_dflt_val: '',
        api_call_fun: () => this.getTrenchLst(),

      },

      {
        dsply_fltr_cd: 'fltr_todate',
        fltr_dflt_val: '',
        api_call_fun: () => this.getTrenchLst(),

      },



      {
        dsply_fltr_cd: 'fltr_dsgns',
        fltr_dflt_val: '',
        api_call_fun: () => this.getDesgns(),

      },
      {
        dsply_fltr_cd: 'fltr_asgn_emp',
        fltr_dflt_val: '',
        api_call_fun: () => this.getAsgndLst(),
      },
    ]
  }
  data = {
    districtLst: [],
    mandalsLst: [],
    svm_lst: [],
    wrdsLst: [],
    wrkTypLsts: [],
    stateLst: [],
    GPLst: [],
    wrkTypLst: [],
    habitationlist: [],
    wrkNtreLst: [],
    wrkSubTypLst: [],
    wrkstatusLst: [],
    categories: [],
    groups: [],
    types: [],
    catgryGrp: [],
    catType: [],
    catAsstCode: [],
    catAsstVndrCode: [],
    site_lst: [],
    links_lst: [],
    docCtgry_lst: [],
    glryLst: [],
    sctrsLst: [],
    years: [],
    schmsLst: [],
    trnchLst: [],
    fType: [],
    mStages: [],
    dsgnsLst: [],
    employees: [],
    ConstuencyLst: []
  };

  fltr_keys = {
    dstrt_id: null,
    ste_id: null,
    dstrt_nm: '',
    mndl_id: null,
    mndl_nm: '',
    svm_id: null,
    wrd_id: null,
    wrd_nm: '',
    svm_nm: '',
    gp_id: null,
    gp_nm: '',
    hbtn_id: null,
    hbtn_nm: '',
    wrk_type_id: null,
    wrk_type_nm: '',
    sb_wrk_type_id: null,
    sb_wrk_type_nm: '',
    wrk_ntre_id: null,
    wrk_ntre_nm: '',
    wrk_sts_id: null,
    wrk_sts_nm: '',
    inpt_srch_txt: '',
    shwLdng: '',
    ast_ctgry_nm: '',
    ast_grp_nm: '',
    ast_cd: '',
    vndr_ast_cd: '',
    ast_ctgry_id: '',
    ast_grp_id: '',
    ast_type_id: '',
    ste_nm: '',
    prvdr_ste_id: '',
    glry_id: '',
    glry_nm: '',
    doc_glry_id: '',
    cntct_glry_id: '',
    sctr_id: '',
    sctr_nm: '',
    schme_id: '',
    schme_nm: '',
    tgle_vw: 'grid',
    ln_trnch_id: '',
    ln_trnch_nm: '',
    tckt_ctgry_id: '',
    stge_mstr_id: '',
    min_sn_at: '',
    mx_sn_at: '',
    dsgns_id: '',
    assgn_empl_id: '',
    frm_dt: '',
    to_dt: '',
    cnsty_id: ''
  }
  usrLgnDtls = null;
  addForm1: any;

  constructor(private apiSrvc: ApiService, private drpDwnFltrSrvc: DropDownFilterService, private fb: FormBuilder) {
    let usr_data = JSON.parse(localStorage.getItem('userdata'));
    console.log(usr_data);
    this.fltr_keys.cnsty_id = usr_data.dstrt_id;


  }


  ngOnChanges() {
    console.log("DS HEADER ------------ ", this.dsHeader)
    if (this.dsHeader && this.dsHeader.shw_fltr) {
      this.preprFltrs(this.dsHeader.fltr_jsn)
    }
  }

  preprFltrs(fltr_jsn) {
    console.log("fltr jons ************************ ", fltr_jsn)
    if (fltr_jsn && fltr_jsn.length) {
      fltr_jsn.filter((f) => {
        for (let index = 0; index < this.settings.fltrs_stngs.length; index++) {
          const element = this.settings.fltrs_stngs[index];
          console.log("element", element, "f ---------- ", f)
          if (element['dsply_fltr_cd'] == f['dsply_fltr_cd']) {
            element['enable'] = true;
            if (element['api_call_fun'] && typeof element['api_call_fun'] == 'function') {
              element.api_call_fun();
            }
            break;
          }
        }
      })
    }
  }

  ngOnInit(): void {
    this.generateYearRange(2000);
    this.asrtForm = new FormGroup({
      ast_ctgry_id: new FormControl('')


    });
    this.getMandals();
    this.apiSrvc.getLgnUsrHyrchyDtls().then((res) => {
      if (res) {
        this.usrLgnDtls = res;
        if (this.usrLgnDtls['hyrchy_id'] == 1) {
          this.settings.shw_all_sclt = true;
        }
      }
    })
  }

  getDistricts() {
    this.fltr_keys.dstrt_id = null;
    this.drpDwnFltrSrvc.getDistricts((res) => {
      this.data.districtLst = res['fltr_res'];
      if (res['fltr_slct_dflt_id']) {
        this.fltr_keys.dstrt_id = res['fltr_slct_dflt_id'];
        this.fltr_keys.dstrt_nm = res['fltr_slct_dflt_nm'];
        this.getMandals()
      }


    })
  }


  getConstuency() {
    this.drpDwnFltrSrvc.getDistricts((res) => {
      this.data.ConstuencyLst = res['fltr_res'];
      if (res['fltr_slct_dflt_id']) {
        this.fltr_keys.dstrt_id = res['fltr_slct_dflt_id'];
        this.fltr_keys.dstrt_nm = res['fltr_slct_dflt_nm'];
        this.getMandals()
      }


    })
  }

  getMandals() {
    this.fltr_keys.mndl_id = null;
    if (parseInt(this.fltr_keys.cnsty_id) > 0) {
      this.fltr_keys.dstrt_id = this.fltr_keys.cnsty_id;
    }
    this.drpDwnFltrSrvc.getMandals(this.fltr_keys.dstrt_id, (res) => {
      this.data.mandalsLst = res['fltr_res'];
      if (res['fltr_slct_dflt_id']) {
        this.fltr_keys.mndl_id = res['fltr_slct_dflt_id'];
        this.fltr_keys.mndl_nm = res['fltr_slct_dflt_nm'];
        this.getGP()
        this.getSvmLst()
        this.getwrdsLst();
      }
      if (this.data.mandalsLst && (this.data.mandalsLst.length == 0 || this.data.mandalsLst.length > 1)) {
        this.settings.shw_all_sclt = true;
      }

    })
  }

  getSvmLst() {
    this.getGP()
    this.fltr_keys.svm_id = null;
    console.log(this.fltr_keys.mndl_id, "mndllllllllllIdddddddddddddddddd")
    this.drpDwnFltrSrvc.getSVM(this.fltr_keys.mndl_id, (res) => {
      console.log('SVM response:', res);
      this.data.svm_lst = res['fltr_res'] || [];
      this.fltr_keys.svm_id = res['fltr_slct_dflt_id'] || null;


    });
  }



  getwrdsLst() {
    console.log(this.fltr_keys.mndl_id, "svmidddddddddddddd")
    this.fltr_keys.wrd_id = null;
    this.drpDwnFltrSrvc.getWardNo(this.fltr_keys.mndl_id, (res) => {
      console.log('Ward response:', res);
      this.data.wrdsLst = res['fltr_res'] || [];
      this.fltr_keys.wrd_id = res['fltr_slct_dflt_id'] || null;
    });
  }
  getWards() {

    this.apiSrvc.get(`admin/wms/wards`).subscribe((res) => {
      console.log(res);

      if (res['status'] == 200) {
        this.data.wrdsLst = res['data'];
      } else {
        this.apiSrvc.shwAlrtMsg('error', 'Alert', res['message']);
      }
    }, (err) => {

      this.apiSrvc.shwAlrtMsg('error', 'Alert', 'Something Went Wrong Please Try Again');


    });
  }


  getwrktyps() {
    this.drpDwnFltrSrvc.getWorkType((res) => {
      console.log(res)
      this.data.wrkTypLsts = res['fltr_res'];
      this.fltr_keys.wrk_type_id = res['fltr_slct_dflt_id'];
      this.getSubWorkType();
    })

  }
  getSubWorkType() {
    this.fltr_keys.sb_wrk_type_id = null;
    this.drpDwnFltrSrvc.getsubWorkType(this.fltr_keys.wrk_type_id, (res) => {
      console.log(res);
      this.data.wrkSubTypLst = res['fltr_res'];
      this.fltr_keys.sb_wrk_type_id = res['fltr_slct_dflt_id'];
    });
  }
  getfiletype() {
    this.apiSrvc.get('admin/filetypes').subscribe(res => {
      console.log(res)
      if (res['status'] === 200) {
        this.data.fType = res['data'];
        console.log(this.data.fType)
      }
      else {
        this.apiSrvc.openNotification('error', '', res["message"]);
      }
    }, err => {
      this.apiSrvc.openNotification('error', '', 'Please Check your Internet Connection and Try Again');
    });
  }
  getmStages() {
    this.apiSrvc.get('admin/mainstages').subscribe(res => {
      console.log(res)
      if (res['status'] === 200) {
        this.data.mStages = res['data'];
        console.log(this.data.mStages)
      }
      else {
        this.apiSrvc.openNotification('error', '', res["message"]);
      }
    }, err => {
      this.apiSrvc.openNotification('error', '', 'Please Check your Internet Connection and Try Again');
    });
  }

  getGP() {
    this.fltr_keys.gp_id = null;
    this.drpDwnFltrSrvc.getGP(this.fltr_keys.mndl_id, (res) => {
      this.data.GPLst = res['fltr_res'];
      if (res['fltr_slct_dflt_id']) {
        this.fltr_keys.gp_id = res['fltr_slct_dflt_id'];
        this.fltr_keys.gp_nm = res['fltr_slct_dflt_nm'];
        this.getHabitation()
      }

    })
  }

  getHabitation() {
    this.fltr_keys.hbtn_id = null;
    this.drpDwnFltrSrvc.getHabitation(this.fltr_keys.gp_id, (res) => {
      this.data.habitationlist = res['fltr_res'];
      this.fltr_keys.hbtn_id = res['fltr_slct_dflt_id'];
      this.fltr_keys.hbtn_nm = res['fltr_slct_dflt_nm'];
    })
  }

  getWorkNtre() {
    this.fltr_keys.wrk_ntre_id = null;
    this.drpDwnFltrSrvc.getWorkNtre((res) => {
      this.data.wrkNtreLst = res['fltr_res'];
      this.fltr_keys.wrk_ntre_id = res['fltr_slct_dflt_id'];
      this.fltr_keys.wrk_ntre_nm = res['fltr_slct_dflt_nm'];
    })
  }

  getWorkStats() {
    this.fltr_keys.wrk_sts_id = null;
    this.drpDwnFltrSrvc.getWorkStats((res) => {
      this.data.wrkstatusLst = res['fltr_res'];
      this.fltr_keys.wrk_sts_id = res['fltr_slct_dflt_id'];
      this.fltr_keys.wrk_sts_nm = res['fltr_slct_dflt_nm'];
    })
  }


  getWorkType() {
    this.fltr_keys.wrk_type_id = null;
    this.drpDwnFltrSrvc.getWorkType((res) => {
      this.data.wrkTypLst = res['fltr_res'];
      this.fltr_keys.wrk_type_id = res['fltr_slct_dflt_id'];
      this.fltr_keys.wrk_type_nm = res['fltr_slct_dflt_nm'];
    })

  }


  getsubWorkType() {
    this.fltr_keys.sb_wrk_type_id = null;
    this.drpDwnFltrSrvc.getsubWorkType(this.fltr_keys.wrk_type_id, (res) => {
      this.data.wrkSubTypLst = res['fltr_res'];
      this.fltr_keys.sb_wrk_type_id = res['fltr_slct_dflt_id'];
      this.fltr_keys.sb_wrk_type_nm = res['fltr_slct_dflt_nm'];
    })
  }

  getFltrSlctdValueName(id, flt_key, flt_val_key, data_src) {
    let key_nm_val = '';
    if (data_src && data_src.length) {
      data_src.filter((d) => {
        if (id == d[`${flt_key}`]) {
          key_nm_val = d[`${flt_val_key}`]
        }

      })
    }
    return key_nm_val;
  }

  getFiltrData() {
    let fltr_kys = {
      dstrt_id: this.fltr_keys.dstrt_id,
      dstrt_nm: this.getFltrSlctdValueName(this.fltr_keys.dstrt_id, 'dstrt_id', 'dstrt_nm', this.data.districtLst),
      ste_id: this.fltr_keys.ste_id,
      mndl_id: this.fltr_keys.mndl_id,
      mndl_nm: this.getFltrSlctdValueName(this.fltr_keys.mndl_id, 'mndl_id', 'mndl_nm', this.data.mandalsLst),
      svm_id: this.fltr_keys.svm_id,
      svm_nm: this.getFltrSlctdValueName(this.fltr_keys.svm_id, 'svm_id', 'svm_nm', this.data.svm_lst),
      wrd_id: this.fltr_keys.wrd_id,
      wrd_nm: this.getFltrSlctdValueName(this.fltr_keys.wrd_id, 'wrd_id', 'wrd_nm', this.data.wrdsLst),
      gp_id: this.fltr_keys.gp_id,
      gp_nm: this.getFltrSlctdValueName(this.fltr_keys.mndl_id, 'gp_id', 'gp_nm', this.data.GPLst),
      hbtn_id: this.fltr_keys.hbtn_id,
      wrk_type_id: this.fltr_keys.wrk_type_id,
      wrk_type_nm: this.getFltrSlctdValueName(this.fltr_keys.wrk_type_id, 'wrk_type_id', 'wrk_type_nm', this.data.wrkTypLsts),
      sb_wrk_type_id: this.fltr_keys.sb_wrk_type_id,
      sb_wrk_type_nm: this.getFltrSlctdValueName(this.fltr_keys.sb_wrk_type_id, 'sb_wrk_type_id', 'sb_wrk_type_nm', this.data.wrkTypLsts),
      wrk_ntre_id: this.fltr_keys.wrk_ntre_id,
      wrk_sts_id: this.fltr_keys.wrk_sts_id,
      inpt_srch_txt: this.fltr_keys.inpt_srch_txt,
      ast_ctgry_id: this.fltr_keys.ast_ctgry_id,
      ast_grp_id: this.fltr_keys.ast_grp_id,
      ast_type_id: this.fltr_keys.ast_type_id,
      prvdr_ste_id: this.fltr_keys.prvdr_ste_id,
      sctr_id: this.fltr_keys.sctr_id,
      sctr_nm: this.getFltrSlctdValueName(this.fltr_keys.sctr_id, 'sctr_id', 'sctr_nm', this.data.sctrsLst),
      schme_id: this.fltr_keys.schme_id,
      schme_nm: this.getFltrSlctdValueName(this.fltr_keys.schme_id, 'schme_id', 'schme_nm', this.data.schmsLst),
      ln_trnch_id: this.fltr_keys.ln_trnch_id,
      ln_trnch_nm: this.getFltrSlctdValueName(this.fltr_keys.ln_trnch_id, 'ln_trnch_id', 'ln_trnch_nm', this.data.trnchLst),
      tckt_ctgry_id: this.fltr_keys.tckt_ctgry_id,
      stge_mstr_id: this.fltr_keys.stge_mstr_id,
      min_sn_at: this.fltr_keys.min_sn_at,
      mx_sn_at: this.fltr_keys.mx_sn_at,
      dsgns_id: this.fltr_keys.dsgns_id,
      assgn_empl_id: this.fltr_keys.assgn_empl_id,
      frm_dt: this.fltr_keys.frm_dt,
      to_dt: this.fltr_keys.to_dt
    }
    this.onGetFilterActionEvntEmtr.emit(fltr_kys)

  }

  entrStchTxt() {
    let fltr_kys = {
      dstrt_id: this.fltr_keys.dstrt_id,
      ste_id: this.fltr_keys.ste_id,
      mndl_id: this.fltr_keys.mndl_id,
      svm_id: this.fltr_keys.svm_id,
      wrd_id: this.fltr_keys.wrd_id,
      gp_id: this.fltr_keys.gp_id,
      hbtn_id: this.fltr_keys.hbtn_id,
      wrk_type_id: this.fltr_keys.wrk_type_id,
      sb_wrk_type_id: this.fltr_keys.sb_wrk_type_id,
      wrk_ntre_id: this.fltr_keys.wrk_ntre_id,
      wrk_sts_id: this.fltr_keys.wrk_sts_id,
      inpt_srch_txt: this.fltr_keys.inpt_srch_txt,
      prvdr_ste_id: this.fltr_keys.prvdr_ste_id,
      ast_ctgry_id: this.fltr_keys.ast_ctgry_id,
      ast_grp_id: this.fltr_keys.ast_grp_id,
      ast_type_id: this.fltr_keys.ast_type_id,
      stge_mstr_id: this.fltr_keys.stge_mstr_id,
      tckt_ctgry_id: this.fltr_keys.stge_mstr_id,
    }
    this.onGetFilterActionEvntEmtr.emit(fltr_kys)

  }
  openFltrs() {
    this.settings.opn_fltrs = !this.settings.opn_fltrs;
  }

  navgtBack() {
    let fltr_kys = {
      dstrt_id: this.fltr_keys.dstrt_id,
      ste_id: this.fltr_keys.ste_id,
      mndl_id: this.fltr_keys.mndl_id,
      gp_id: this.fltr_keys.gp_id,
      hbtn_id: this.fltr_keys.hbtn_id,
      wrk_type_id: this.fltr_keys.wrk_type_id,
      sb_wrk_type_id: this.fltr_keys.sb_wrk_type_id,
      wrk_ntre_id: this.fltr_keys.wrk_ntre_id,
      wrk_sts_id: this.fltr_keys.wrk_sts_id,
      inpt_srch_txt: this.fltr_keys.inpt_srch_txt,
      ast_ctgry_id: this.fltr_keys.ast_ctgry_id,
      ast_grp_id: this.fltr_keys.ast_grp_id,
      ast_type_id: this.fltr_keys.ast_type_id,
      bck_btn_clckd: true
    }
    this.onGetFilterActionEvntEmtr.emit(fltr_kys)
  }

  refresh() {
    let fltr_kys = {
      dstrt_id: this.fltr_keys.dstrt_id,
      ste_id: this.fltr_keys.ste_id,
      mndl_id: this.fltr_keys.mndl_id,
      gp_id: this.fltr_keys.gp_id,
      hbtn_id: this.fltr_keys.hbtn_id,
      wrk_type_id: this.fltr_keys.wrk_type_id,
      sb_wrk_type_id: this.fltr_keys.sb_wrk_type_id,
      wrk_ntre_id: this.fltr_keys.wrk_ntre_id,
      wrk_sts_id: this.fltr_keys.wrk_sts_id,
      inpt_srch_txt: this.fltr_keys.inpt_srch_txt,
      ast_ctgry_id: this.fltr_keys.ast_ctgry_id,
      ast_grp_id: this.fltr_keys.ast_grp_id,
      ast_type_id: this.fltr_keys.ast_type_id,
      bck_btn_clckd: true,
      rfrsh_in : true
    }
    this.onGetFilterActionEvntEmtr.emit(fltr_kys)
  }


  showFilter(fltr_cd) {
    let shw_fltr = false;
    for (let index = 0; index < this.settings.fltrs_stngs.length; index++) {
      const element = this.settings.fltrs_stngs[index];
      if (element['dsply_fltr_cd'] == fltr_cd && element['enable']) {
        shw_fltr = true;
        break;
      }
    }
    return shw_fltr;
  }

  clrInptSrchTxt() {
    console.log("____________")
    this.fltr_keys.inpt_srch_txt = '';
  }

  getCategories() {
    console.log("kkkkkkkkkk")
    this.shwLdng = true
    this.apiSrvc.get(`asset/tracking/categories`).subscribe((res) => {
      console.log(res, 'iiiiiiiiiiiiiii')
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.categories = res['data']
      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    }, (err) => {
      this.shwLdng = false;
    })


  }

  getGroups() {
    this.shwLdng = true
    this.apiSrvc.get(`asset/tracking/asset/category/groups/${this.catid}`).subscribe((res) => {
      console.log(res, 'nnnnnnnnnnnnnnnn')
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.groups = res['data']
      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    }, (err) => {
      this.shwLdng = false;

    })

  }

  getType() {

    this.shwLdng = true
    this.apiSrvc.get(`asset/tracking/asset/category/types/${this.catid}`).subscribe((res) => {
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.types = res['data']
      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    }, (err) => {
      this.shwLdng = false;
    })

  }



  getCategoryGrp(e) {
    console.log(e)
    console.log(this.asrtForm.value.ast_ctgry_id)
    this.catid = e.value
    this.flag = false;
    this.data.categories.filter((c) => {
      if (c.ast_ctgry_id == e.value) {
        this.catgryGrp = c.ast_grp_lbl_tx;
        this.catType = c.ast_type_lbl_tx;
        this.catAsstCode = c.ast_cd_lbl_tx;
        this.catAsstVndrCode = c.vndr_ast_cd_lble_tx
        this.flag = true;
        console.log(this.asrtForm.value.ast_ctgry_id)
        this.getGroups();
        this.getType();
      }
    })
  }

  getSiteLst() {
    console.log('--------------- getSiteLst');

    this.apiSrvc.get(`website/prtl/site_lst`).subscribe((res) => {
      console.log(res, 'iiiiiiiiiiiiiii')
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.site_lst = res['data'];
        if (this.data.site_lst && (this.data.site_lst.length == 0 || this.data.site_lst.length > 1)) {
          this.settings.shw_all_sclt = true;
        }
      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    }, (err) => {
      this.shwLdng = false;
    })

  }

  getLinksCtgry() {
    let rte = `website/Links_Gallery`
    this.apiSrvc.get(rte).subscribe((res) => {
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.links_lst = res['data'];


        if (this.data.links_lst && (this.data.links_lst.length == 0 || this.data.links_lst.length > 1)) {
          this.settings.shw_all_sclt = true;
        }


      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    }, (err) => {
      this.shwLdng = false;
    })
  }

  getDocCtgry() {
    let rte = `website/Document_Gallery`
    this.apiSrvc.get(rte).subscribe((res) => {
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.docCtgry_lst = res['data'];


        if (this.data.docCtgry_lst && (this.data.docCtgry_lst.length == 0 || this.data.docCtgry_lst.length > 1)) {
          this.settings.shw_all_sclt = true;
        }


      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    }, (err) => {
      this.shwLdng = false;
    })
  }
  hndlrtx = 'Contcts_Gallery';
  getPgEdt() {
    this.shwLdng = true;
    this.apiSrvc.get('website/' + this.hndlrtx).subscribe((res) => {
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.glryLst = res['data'];

        if (this.data.glryLst && (this.data.glryLst.length == 0 || this.data.glryLst.length > 1)) {
          this.settings.shw_all_sclt = true;
        }


      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    });
  }

  getSctrsLst() {
    this.shwLdng = true;
    this.apiSrvc.get('/core/api/master/loan-sectors/list').subscribe((res) => {
      console.log(res)
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.sctrsLst = res['data'];
        if (this.data.sctrsLst && (this.data.sctrsLst.length == 0 || this.data.sctrsLst.length > 1)) {
          this.settings.shw_all_sclt = true;
        }

      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    });
  }

  generateYearRange(startYear: number) {
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= startYear; year--) {
      this.years.push(year);
    }

    console.log(this.years);

    this.selectedYear = currentYear;
  }

  onTgleChange(event) {
    if (event.value == 'table') {
      this.fltr_keys.tgle_vw = 'table';
    } else if (event.value == 'card') {
      this.fltr_keys.tgle_vw = 'card';
    }
    let fltr_kys = {
      dstrt_id: this.fltr_keys.dstrt_id,
      ste_id: this.fltr_keys.ste_id,
      svm_id: this.fltr_keys.svm_id,
      wrd_nm: this.fltr_keys.wrd_id,
      mndl_id: this.fltr_keys.mndl_id,
      gp_id: this.fltr_keys.gp_id,
      hbtn_id: this.fltr_keys.hbtn_id,
      wrk_type_id: this.fltr_keys.wrk_type_id,
      sb_wrk_type_id: this.fltr_keys.sb_wrk_type_id,
      wrk_ntre_id: this.fltr_keys.wrk_ntre_id,
      wrk_sts_id: this.fltr_keys.wrk_sts_id,
      inpt_srch_txt: this.fltr_keys.inpt_srch_txt,
      ast_ctgry_id: this.fltr_keys.ast_ctgry_id,
      ast_grp_id: this.fltr_keys.ast_grp_id,
      ast_type_id: this.fltr_keys.ast_type_id,
      bck_btn_clckd: true,
      tgle_vw: this.fltr_keys.tgle_vw,
    }

    this.onGetFilterActionEvntEmtr.emit(fltr_kys)
  }
  getStates() {
    console.log('statessssssssssssssssssssssssssss')
    this.fltr_keys.ste_id = null;
    this.drpDwnFltrSrvc.getStates((res) => {
      console.log(res)
      this.data.stateLst = res['fltr_res'];
      if (res['fltr_slct_dflt_id']) {
        this.fltr_keys.ste_id = res['fltr_slct_dflt_id'];
        this.fltr_keys.ste_nm = res['fltr_slct_dflt_nm'];
        this.getDistricts()
      }


    })
  }


  getSchmsLst() {
    this.shwLdng = true;
    this.apiSrvc.get(`/core/api/master/loan-sectors/${this.fltr_keys.sctr_id}/loan-schemes`).subscribe((res) => {
      console.log(res)
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.schmsLst = res['data'];
        if (this.data.schmsLst && (this.data.schmsLst.length == 0 || this.data.schmsLst.length > 1)) {
          this.settings.shw_all_sclt = true;
        }

      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    });
  }



  getTrenchLst() {
    this.shwLdng = true;
    let hldr = `loan-trenches`
    this.apiSrvc.get(`/core/api/master/${hldr}`).subscribe((res) => {
      console.log(res)
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.trnchLst = res['data'];
        if (this.data.trnchLst && (this.data.trnchLst.length == 0 || this.data.trnchLst.length > 1)) {
          this.settings.shw_all_sclt = true;
        }
        else if (this.data.trnchLst.length == 1) {
          this.fltr_keys.ln_trnch_nm = this.data.trnchLst[0].ln_trnch_nm

        }

      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    });
  }


  getDesgns() {
    this.shwLdng = true;
    let postdata = {
      hndlr_tx: 'PRPSL_FILE',
      est_amt: null,
    };
    this.apiSrvc.post(postdata, 'file-tracking/wrk/dsgn').subscribe((res) => {
      console.log(res)
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.dsgnsLst = res['data']
        if (this.data.dsgnsLst && (this.data.dsgnsLst.length == 0 || this.data.dsgnsLst.length > 1)) {
          this.settings.shw_all_sclt = true;
        }

      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    });
  }


  getAsgndLst() {
    this.shwLdng = true;
    let postdata = {
      // slctDsgn: this.fileUpdateForm.value.dsgns_id,

    };
    this.apiSrvc.post(postdata, 'file-tracking/employee/work/based/list').subscribe((res) => {
      console.log(res)
      this.shwLdng = false;
      if (res['status'] == 200) {
        this.data.employees = res['data']
        if (this.data.employees && (this.data.employees.length == 0 || this.data.employees.length > 1)) {
          this.settings.shw_all_sclt = true;
        }

      } else {
        this.apiSrvc.openNotification('success', '', res["message"]);
      }
    });
  }

}
